/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum WebsiteStatus {
    DRAFT = 'draft',
    PUBLISHING = 'publishing',
    PUBLISHED = 'published',
    FAILED = 'failed',
}
